module.exports = __webpack_public_path__ + "img/img-send-sec-03-01.png";